
const state = {
    supplierList: JSON.parse(localStorage.getItem('setSupplierList'))
}
const getters = {

}
const mutations = {
 
  setSupplierList(state, data) {
    state.supplierList = data;
  },
}

const actions = {
  getWarehousingNo (context, params) {
    
  }
}


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}


// WEBPACK FOOTER //
// ./src/modules/contol/vuex.js